import { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import axios from 'axios';
import { PROXY } from '../../../components/constants'
import { Link } from "react-router-dom";
import { truncateText } from "../../../components/functions";
import { formatTitleForURL } from "../../../components/functions";

export default function MotionCard() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        fetchPosts();
    }, [])

    const fetchPosts = () => {
        axios.get(`${PROXY}/fetch_posts`)
        .then(res => {
            const sortedPosts = res.data.sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                return dateB - dateA;
            });
            setPosts(sortedPosts)
        })
        .catch(err => console.error(err));
    }

    return (
        <Carousel 
            showThumbs={false} 
            showStatus={false}
            showIndicators={false}
            transitionTime={1500} 
            infiniteLoop 
            emulateTouch 
            stopOnHover
        >
            <div className="flex sm:flex-col lg:flex-row">
                {posts.slice(0, 2).map((motion, index) => {
                     const { truncated, isTruncated } = truncateText(motion.details, 30);

                     return (
                         <div key={index} className={`landing-card landing-card-delay-${index + 1} group m-1 flex w-full overflow-hidden rounded-2xl border border-zinc-700/80 bg-gradient-to-br from-zinc-900 to-[#0b0b0b] text-left transition duration-500 hover:border-zinc-500 sm:flex-col`}>
                         <img alt={motion.title} src={`${PROXY}/uploads/images/${motion.image}`} className="h-72 w-72 shrink-0 object-cover grayscale transition duration-700 group-hover:grayscale-0 sm:w-full" />
                         <div className="p-7 text-zinc-300">
                             <h3 className="font-fontMontserrat text-2xl leading-tight text-zinc-100 lg:text-3xl">{motion.title}</h3>
                             <h2 className="mt-4 font-mono text-xs tracking-[0.12em] text-zinc-500">{motion.date}</h2>
                             <h2 className="mt-1 text-sm text-zinc-400">Quilaton Law Office</h2>
                             <p className="mb-5 mt-5 leading-7 text-zinc-400">{truncated}</p>
                             <Link to={`/practices/posts/${formatTitleForURL(motion.title)}/`} className='text-sm tracking-[0.12em] text-zinc-200 transition hover:text-white hover:underline'>
                                 Read more...
                             </Link>
                         </div>
                     </div>
                     )
                })}
            </div>
            <div className="flex sm:flex-col lg:flex-row">
                {posts.slice(2, 4).map((motion, index) => {
                    const { truncated, isTruncated } = truncateText(motion.details, 30);

                    return (
                        <div key={index} className={`landing-card landing-card-delay-${index + 1} group m-1 flex w-full overflow-hidden rounded-2xl border border-zinc-700/80 bg-gradient-to-br from-zinc-900 to-[#0b0b0b] text-left transition duration-500 hover:border-zinc-500 sm:flex-col`}>
                        <img alt={motion.title} src={`${PROXY}/uploads/images/${motion.image}`} className="h-72 w-72 shrink-0 object-cover grayscale transition duration-700 group-hover:grayscale-0 sm:w-full" />
                        <div className="p-7 text-zinc-300">
                            <h3 className="font-fontMontserrat text-2xl leading-tight text-zinc-100 lg:text-3xl">{motion.title}</h3>
                            <h2 className="mt-4 font-mono text-xs tracking-[0.12em] text-zinc-500">{motion.date}</h2>
                            <h2 className="mt-1 text-sm text-zinc-400">Quilaton Law Office</h2>
                            <p className="mb-5 mt-5 leading-7 text-zinc-400">{truncated}</p>
                            <Link to={`/practices/posts/${formatTitleForURL(motion.title)}/`} className='text-sm tracking-[0.12em] text-zinc-200 transition hover:text-white hover:underline'>
                                Read more...   
                            </Link>
                        </div>
                    </div>
                    )
                })}
            </div>
        </Carousel>
    );
}
